import { createNaturalArithmeticTask, randInt, simpleSubtractionExplanation } from "./sharedNaturalArithmetic";

function pickData() {
  const a = randInt(4, 9);
  const b = randInt(1, a - 1);
  return { a, b, op: "-", result: a - b };
}

const mod = createNaturalArithmeticTask({
  type: "NaturalSubOneDigitNoBorrowTask",
  pickData,
  explain: simpleSubtractionExplanation,
});

export const generateTask = mod.generateTask;
export const renderTask = mod.renderTask;
export const renderInput = mod.renderInput;
export const checkAnswer = mod.checkAnswer;
export const renderAnswer = mod.renderAnswer;
export const renderUserAnswer = mod.renderUserAnswer;
export const renderExplanation = mod.renderExplanation;
